export const featureflagsProductAnnouncementBannerProperties = {
  layout: "upper_placement" as "upper_placement" | "lower_placement",
};
